// hooks/useAccountsReceivable.js
import { useQuery } from '@tanstack/react-query';
import { reactQueryFinanceDefaults } from './queryDefaults';
import apiService from '../../services/api';
import { ENDPOINTS } from '../../services/endpoints';

const useAccountsReceivable = () => {
  const fetchARData = async () => {
    const response = await apiService.get(ENDPOINTS.FINANCE_AR_DASHBOARD);
    
    if (!response) {
      throw new Error("No A/R data returned from API");
    }
    
    return {
      current_ar: response.current_ar || 0,
      overdue_ar: response.overdue_ar || 0,
      customers_overdue_count: response.customers_overdue_count || 0,
      customers_aging: response.customers_aging || [],
      lastUpdated: new Date().toISOString(),
    };
  };

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
    } = useQuery({
      queryKey: ['accountsReceivable'],
      queryFn: fetchARData,
      ...reactQueryFinanceDefaults,
    });

  return {
    // A/R data
    current_ar: data?.current_ar || 0,
    overdue_ar: data?.overdue_ar || 0,
    customers_overdue_count: data?.customers_overdue_count || 0,
    customers_aging: data?.customers_aging || [],
    lastUpdated: data?.lastUpdated || null,
    
    // Loading states
    loading: isLoading,
    refreshing: isFetching,
    
    // Error handling
    error: isError ? (error?.message || 'Failed to load A/R data') : null,
    isError,
    
    // Status
    initialized: !!data,
    
    // Actions
    refetch,
  };
};

export { useAccountsReceivable };
